<template>
  <div class="keywords">
    <v-card
      v-for="(item, key, index) in keywordsList"
      :key="index"
      class="ma-2"
      flat
    >
      <v-card-title class="py-2 px-6 body-1">
        <v-icon class="mr-2">{{ item.icon }}</v-icon>
        {{ item.label }}
        <v-chip v-if="item.multiple" label small>多选</v-chip>
      </v-card-title>
      <v-card-text>
        <v-chip-group v-if="item.values" column>
          <v-chip
            v-for="(chip, i) in item.values"
            @click="fnKeywords(chip.title)"
            :key="i"
            :value="chip.id"
            outlined
            label
            small
          >
            {{ chip.title }}
          </v-chip>
        </v-chip-group>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "CKeywords",
  props: {
    items: { type: Object, required: false, default: () => {} },
  },
  data: () => ({
    keywordsList: [],
  }),
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.keywordsList = this.items;
    },
    fnKeywords(keywords) {
      this.$router.push(`/users?keywords=${keywords}`);
    },
  },
};
</script>
